import styled from "styled-components";

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    min-height: 320px;
    text-align: center;
`;
